import React, { Component } from 'react'
import DrawControl from 'react-mapbox-gl-draw'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { array } from 'prop-types'
import { controls, cursorListeners, clearCursors } from './utils'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import './styles/DrawControl.css'

class Draw extends Component {
  componentDidMount = () => {
    cursorListeners()
  }

  handleSelect = e => {
    if (e.features.length > 0) {
      if (e.features[0].geometry.type === 'Point') {
        let center = e.features[0].geometry.coordinates
        this.props.history.push(
          `/${center[0]}:${center[1]}/${this.props.category.join(',')}/${50}`
        )
      } else if (e.features[0].geometry.type === 'Polygon') {
        const coord = e.features[0].geometry.coordinates[0]
          .map(coord => coord.join(',').replace(',', ':'))
          .join(',')
        this.props.history.push(
          `/${coord}/${this.props.category.join(',')}/${300}`
        )
      }
    }
  }

  handleModeChange = action => {
    if (action.mode === 'simple_select') {
      clearCursors()
    }
  }

  render() {
    return (
      <DrawControl
        ref={drawControl => {
          this.drawControl = drawControl
        }}
        onDrawSelectionChange={e => this.handleSelect(e)}
        onDrawModeChange={action => this.handleModeChange(action)}
        position="top-right"
        controls={controls}
      />
    )
  }
}

Draw.propTypes = {
  category: array.isRequired,
}

const mapStateToProps = ({ spi }) => ({
  category: spi.category,
})

export default withRouter(connect(mapStateToProps)(Draw))



// WEBPACK FOOTER //
// ./src/components/Map/MapTools/DrawControl.jsx